import { useNavigate } from "react-router";

export const duplicateAction = () => {
    return (props) => {
        // eslint-disable-next-line no-unused-vars
        const { component: MenuItem, onClick, params, ...restProps } = props;
        const value = "duplicate";
        const label = "Duplicate";

        const navigate = useNavigate();
        const handleOnClick = () => {
            navigate(`create`, { state: JSON.stringify(params) });
            onClick();
        };
        return (
            <MenuItem
                key={value}
                value={value}
                label={label}
                onClick={handleOnClick}
                {...restProps}
            >
                {label}
            </MenuItem>
        );
    };
};
